<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @import "./assets/css/main.css";
  @import "./assets/css/color-dark.css"; 
  .substring { overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
  .ck-balloon-panel { z-index: 99999 !important; }
  .ck-balloon-panel--visible { z-index: 99999 !important; }
  .ck-powered-by { display: none !important; }
  .el-message { /* 居中布局 */ top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; margin: 0 !important; position: fixed !important; z-index: 9999 !important; /* 外观美化 */ border-radius: 12px !important; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important; padding: 20px 30px !important; font-size: 16px !important; line-height: 1.5 !important; max-width: 400px !important; width: auto !important; border: none !important; /* 移除默认边框 */ /* 动画效果 */ animation: messageFade 0.3s ease-in-out !important; } .el-message__icon { font-size: 24px !important; margin-right: 12px !important; } @keyframes messageFade { from { opacity: 0; transform: translate(-50%, -50%) scale(0.9); } to { opacity: 1; transform: translate(-50%, -50%) scale(1); } }
</style>



// WEBPACK FOOTER //
// src/App.vue